// extracted by mini-css-extract-plugin
module.exports = {"ModalContainer":"style_ModalContainer__1bN0W","CloseBtn":"style_CloseBtn__1j8RN","Body":"style_Body__HyMOB","ModalTitle":"style_ModalTitle__3inks","RowText":"style_RowText__2Resm"};